import { render } from "./user-booking-cancelled.vue?vue&type=template&id=b87af722"
import script from "./user-booking-cancelled.vue?vue&type=script&lang=js"
export * from "./user-booking-cancelled.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__